import { IconComponentsProps } from './types';

const FilterIcon = ({ fill = '#008EFF', ...props }: IconComponentsProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.425 6H22.5V7.5H19.425C19.05 9.225 17.55 10.5 15.75 10.5C13.95 10.5 12.45 9.225 12.075 7.5H1.5V6H12.075C12.45 4.275 13.95 3 15.75 3C17.55 3 19.05 4.275 19.425 6ZM13.5 6.75C13.5 8.025 14.475 9 15.75 9C17.025 9 18 8.025 18 6.75C18 5.475 17.025 4.5 15.75 4.5C14.475 4.5 13.5 5.475 13.5 6.75ZM4.575 18H1.5V16.5H4.575C4.95 14.775 6.45 13.5 8.25 13.5C10.05 13.5 11.55 14.775 11.925 16.5H22.5V18H11.925C11.55 19.725 10.05 21 8.25 21C6.45 21 4.95 19.725 4.575 18ZM10.5 17.25C10.5 15.975 9.525 15 8.25 15C6.975 15 6 15.975 6 17.25C6 18.525 6.975 19.5 8.25 19.5C9.525 19.5 10.5 18.525 10.5 17.25Z"
      fill={fill}
    />
  </svg>
);

export default FilterIcon;
